import PinwheelModal, { type PinwheelModalProps } from "@pinwheel/react-modal";
import { InstitutionFeatures } from "byzantine/src/types";
import AtomicModal, { type AtomicModalProps } from "./AtomicModal";

type DirectDepositSSOProps = {
  type: InstitutionFeatures["direct_deposit"];
} & Omit<PinwheelModalProps, "onSuccess"> &
  Omit<AtomicModalProps, "onSuccess"> & {
    onSuccess?: ((payload?: any) => void) | (() => void);
  };

const DirectDepositSSO = ({ type, ...props }: DirectDepositSSOProps) => {
  switch (type) {
    case "atomic": {
      // Extract only AtomicModalProps
      const { open, linkToken, onSuccess, onExit } = props;
      // Transform onSuccess to no-argument function for Atomic
      const atomicOnSuccess = onSuccess ? () => onSuccess() : undefined;
      return (
        <AtomicModal
          open={open}
          linkToken={linkToken}
          onSuccess={atomicOnSuccess}
          onExit={onExit}
        />
      );
    }
    case "pinwheel":
      return <PinwheelModal {...props} />;
    default:
      return null;
  }
};

export default DirectDepositSSO;
